import { EPasswordStrength } from "../utils/password-strength.types";

// NOTE: NSAI-5324 — length bonuses on top of the policy minimum. A password
// that meets the policy at 8 characters scores "medium"; each threshold below
// adds a point, and any point left after penalties makes it "strong".
export const PASSWORD_STRENGTH_LENGTH_THRESHOLDS = [12, 16] as const;

export const PASSWORD_STRENGTH_COMMON_WORD_PENALTY = 2;

export const PASSWORD_STRENGTH_PREDICTABLE_RUN_PENALTY = 1;

// NOTE: shortest run of repeated, sequential or keyboard-adjacent characters
// that counts as predictable ("aaaa", "1234", "dcba", "qwer").
export const PASSWORD_STRENGTH_MIN_RUN_LENGTH = 4;

// NOTE: the base words that dominate breached-password lists once the policy
// forces a capital, a digit and a symbol onto them ("Password1!",
// "Welcome2025!"). Matched after undoing common character substitutions, so
// "P@ssw0rd" counts too. Five letters or more, to keep a short word from
// matching inside an unrelated random string.
export const PASSWORD_STRENGTH_COMMON_WORDS = [
  "password",
  "passwort",
  "qwerty",
  "letmein",
  "welcome",
  "admin",
  "iloveyou",
  "monkey",
  "dragon",
  "football",
  "baseball",
  "sunshine",
  "princess",
  "master",
  "login",
  "shadow",
  "superman",
  "trustno",
  "starwars",
  "whatever",
  "freedom",
  "changeme",
  "secret",
  "hello",
  "summer",
  "winter",
  "spring",
  "autumn",
] as const;

export const PASSWORD_STRENGTH_SUBSTITUTIONS: Readonly<Record<string, string>> =
  {
    "0": "o",
    "1": "i",
    "!": "i",
    "3": "e",
    "4": "a",
    "@": "a",
    "5": "s",
    $: "s",
    "7": "t",
  };

export const PASSWORD_STRENGTH_KEYBOARD_ROWS = [
  "1234567890",
  "qwertyuiop",
  "asdfghjkl",
  "zxcvbnm",
] as const;

export const PASSWORD_STRENGTH_SEGMENT_COUNT = 3;

export const PASSWORD_STRENGTH_FILLED_SEGMENTS: Readonly<
  Record<EPasswordStrength, number>
> = {
  [EPasswordStrength.WEAK]: 1,
  [EPasswordStrength.MEDIUM]: 2,
  [EPasswordStrength.STRONG]: 3,
};

// NOTE: keys in the `auth` namespace. Literal keys, so a typed `t()` accepts
// them without building one.
export const PASSWORD_STRENGTH_LABEL_KEYS = {
  [EPasswordStrength.WEAK]: "password_strength.weak",
  [EPasswordStrength.MEDIUM]: "password_strength.medium",
  [EPasswordStrength.STRONG]: "password_strength.strong",
} as const satisfies Record<EPasswordStrength, string>;
